module.exports = __webpack_public_path__ + "img/firsov_500.9c57e5f2.jpg";